<template>
  <div class="account tableStyle">
    <el-row>
      <el-col :span="24">
        <el-form :inline="true" size="small">
          <el-form-item label="订单号：" class="screen">
            <el-input v-model="queryForm.order_no" placeholder="请输入订单号"></el-input>
          </el-form-item>          
          <el-form-item label="分账账户：" class="screen">
            <el-input v-model="queryForm.card_no" placeholder="请输入订单号"></el-input>
          </el-form-item>
          <el-form-item label="状态：" class="screen">
            <el-select v-model="queryForm.status" placeholder="请选择" @change="getTableList('query')">
              <el-option label="发启" :value="0"></el-option>
              <el-option label="失败" :value="1"></el-option>
              <el-option label="成功" :value="10"></el-option>
              <!-- 状态，0发启，1失败，10成功 -->
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getTableList('query')">查询</el-button>
            <el-button @click="resetQuery">重置</el-button>
            <el-button type="primary" @click="handleCabCash">发起分账</el-button>
            <el-button type="primary" @click="handleCabCashSetting">设置分账账户</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <div class="tableArea">
      <el-table :data="tableData" class="table-border" height="100%">
        <el-table-column type="index" label="序号" align="center"></el-table-column>        
        <el-table-column prop="order_no" label="分账订单号" align="center"></el-table-column>
        <el-table-column prop="card_no" label="分账账号" align="center"></el-table-column>
        <el-table-column prop="ps" label="分账说明" align="center"></el-table-column>
        <el-table-column prop="money" label="分账金额(元)" align="center"></el-table-column>
        <el-table-column prop="updated_at" label="分账时间" align="center"></el-table-column>
        <el-table-column prop="status_str" label="分账结果" align="center"></el-table-column>
        <el-table-column prop="error_str" label="失败原因" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0">发起</span>
            <span v-if="scope.row.status === 1">失败</span>
            <span v-if="scope.row.status === 10">成功</span>
          </template>
        </el-table-column>


        <!-- <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" plain size="mini">查看</el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>

    <div class="pageFoot flex">
      <el-pagination
        layout="total, prev, pager, next, sizes"
        background
        :page-size="queryForm.size"
        :total="total"
        :page-sizes="[20,50,100,200,500,1000]"
        @size-change="sizeChange"
        @current-change="changePage">
      </el-pagination>
    </div>

    <!-- 发起分账 -->
    <el-dialog title="发起分账" :visible.sync="dialogVisible" width="30%" @close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="90px">
        <el-form-item label="金额" prop="money">
          <el-input v-model="ruleForm.money" size="small"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="ps">
          <el-input v-model="ruleForm.ps" size="small"></el-input>
        </el-form-item>                
      </el-form>
      <div class="mark">
          标注：请于工作日10:00至16:30之间操作。
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="medium">取 消</el-button>
        <el-button type="primary" size="medium" @click="handleCabCashSubmit('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 设置分账账户 -->
    <el-dialog title="设置分账账户" :visible.sync="dialogVisibleSetting" width="30%" @close="handleCloseSetting">
      <el-form :model="ruleFormSetting" :rules="rulesSetting" ref="ruleFormSetting" label-width="90px">
        <el-form-item label="转账账户" prop="card_no">
          <el-input v-model="ruleFormSetting.card_no" size="small"></el-input>
        </el-form-item>      
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleSetting = false" size="medium">取 消</el-button>
        <el-button type="primary" size="medium" @click="handleCabCashSettingSubmit('ruleFormSetting')">确 定</el-button>
      </span>
    </el-dialog>    



    
  </div>
</template>
<script>
export default {
  data() {
    return {
      // size: 20,
      // page: 1,
      total: 0,
      queryForm:{
        page: 1,
        size: 20,
        order_no:'',
        status:'',
        card_no:'',
      },
  
      tableData: [],
      dialogVisible: false,
      ruleForm:{
        money:null,
        ps:'',
      },
      rules: {
        money: [
          { required: true, message: '请输入金额', trigger: 'blur' },
        ],
        ps: [
          { required: true, message: '请输入分账说明', trigger: 'blur' },
        ],        
      },

      dialogVisibleSetting:false,
      ruleFormSetting: {
        card_no:'', //转账账户
        id:'', //修改需要传
      },

      rulesSetting: {
        card_no: [
          { required: true, message: '请输入转账账户', trigger: 'blur' },
        ],    
      },      


    };
  },
  created() {
    this.getTableList();
  },
  methods: {

    // 获取table
    getTableList(type){
      if(type === 'query'){
        this.queryForm.page = 1;
      }

      this.$api.fenZhangList(this.queryForm).then(res=>{
          if (res.code === 200) {
              this.total = res.data.count;
              this.tableData = res.data.list;
          } else {
            return this.$message.error(res.msg);
          }
      });
    },


    //选择物业厂商
    handleSelectCompany(type,str){
      if(str==='query'){        
        this.queryForm.cid = ''; 
        this.allManufacturerSearch = [];
      }
     
      // if(str==='dialog'){
      //   this.addForm.cid = '';
      //   this.allManufacturer = [];
      // }
      
      
      this.getAllManufacturer(type,str);
    },


    // 获取所有厂商列表
    getAllManufacturer(type,str){
      let params = {
        type: type  //类型 1厂商 2物业
      }
      this.$http.get(this.common.admin+'/admin/companyAllList',{params}).then(res => {
        if(res.code === 200){
          if(str==='query'){
            this.allManufacturerSearch = res.data;
          }
          // if(str==='dialog'){
          //   this.allManufacturer = res.data;
          // }
          
          // this.allManufacturer = [{id: 0, name: '车安堡自营'}, ...res.data];
        }else{
          this.$message.error(res.msg);
        }
      });
    },
    // 获取所有桩群
    getAllStation(val, type){
      let params = {
        cid: val,
        page: 1,
        size: 10000,
        created: 0  //0全部，1未配置的 //需求变更为不管有没有配置过都可选
        // created: type === 'add' ? 1 : 0  //0全部，1未配置的  
      };
      this.$http.post(this.common.admin + '/api/getGroupList',params).then(res => {
        if(res.code === 200){
          if(type === 'add'){
            // this.addStations = [{id: 0, name: '全部'}, ...res.data.list];
            this.addStations = [...res.data.list]; //去掉全部桩群
          }else if(type === 'edit'){
            this.addStations = res.data.list;
          }else{
            this.allStation = res.data.list;
          }
        }else{
          return this.$message.error(res.msg);
        }
      });
    },
    judgeManufacturer(){
      if(this.queryForm.cid === ''){
        return this.$message.error('请先选择所属厂商/物业');
      }
    },


    // 重置查询条件
    resetQuery() {
      this.queryForm = {
        page: 1,
        size: 20,
        order_no:'',
        status:'',
        card_no:'',
      };      
      this.getTableList();
    },
    // 打开新建弹窗
    openDialog(){
      this.dialogVisible = true;
    },
    // 关闭新建弹窗
    closeDialog(){
      this.dialogVisible = false;
    },
    // 弹窗获取桩群
    goGetStatios(val, type){
      this.getAllStation(val, type ? type : 'add');
    },

    // 翻页
    changePage(page) {
      this.queryForm.page = page;
      this.getTableList();
    },
    sizeChange(val){
      this.queryForm.size = val;
      this.getTableList();
    },

    //发起分账
    handleCabCash(){
      this.dialogVisible = true;
    },


    handleClose(){
      this.$refs.ruleForm.resetFields();
    },

    //提交发起分账
    handleCabCashSubmit(formName){
      this.$refs[formName].validate(valid=>{
        if(valid){
          this.$api.fenZhang(this.ruleForm).then(res=>{
            this.dialogVisible = false;
            this.getTableList();
            if(res.code === 200){
              this.$message.success('提交成功');              
            }
            
          })
        }
      })

    },

    
    //设置分账账户
    handleCabCashSetting(){
      this.dialogVisibleSetting = true;

      //获取分账账户信息
      this.$api.getCabSettings().then(res=>{
        if(res.code === 200){
          this.ruleFormSetting = res.data.list;
        }
      })

    },

    handleCloseSetting(){
      this.ruleFormSetting = {
        card_no:'',
      }
      this.$refs.ruleFormSetting.resetFields();
    },    

    handleCabCashSettingSubmit(formName){
      this.$refs[formName].validate(valid=>{
        if(valid){
          this.$api.saveCabSettings(this.ruleFormSetting).then(res=>{
            if(res.code === 200){
              this.$message.success('设置成功');
              this.dialogVisibleSetting = false;
            }
            
          })
        }
      })
    }





  },
};
</script>
<style lang="less" scoped>
.account{
  height: 100%;
  display: flex;
  flex-direction: column;

  .tableArea{
    flex: 1;
    min-height: calc(100% - 167px);
  }
  .pageFoot{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .tongji{
      font-size: 14px;
    }
  }
}

.mark{color:#f00;padding-left:50px;}

</style>